import { create } from 'zustand'
import projectStore, { ProjectStore } from './stores/project-store'

const useProjectStore = create<ProjectStore>((...a) => ({
  ...projectStore(...a),
}))

export default useProjectStore
